exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tree-view[data-v-629d2576] {\n    padding-bottom: 8px;\n    padding-top: 8px;\n    user-select: none;\n}\n", ""]);

// exports
